import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatFlat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTAuNVYxMi41SDlWNi41SDE4QzIwLjIxIDYuNSAyMiA4LjI5IDIyIDEwLjVaTTIgMTMuNVYxNS41SDhWMTcuNUgxNlYxNS41SDIyVjEzLjVIMlpNNy4xNCAxMS42QzguMyAxMC40MSA4LjI4IDguNTIgNy4xIDcuMzZDNS45MSA2LjIgNC4wMiA2LjIyIDIuODYgNy40QzEuNyA4LjU5IDEuNzIgMTAuNDggMi45IDExLjY0QzQuMDkgMTIuOCA1Ljk4IDEyLjc4IDcuMTQgMTEuNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatFlat = createIcon('AirlineSeatFlat', [
  [
    'path',
    {
      d: 'M22 10.5V12.5H9V6.5H18C20.21 6.5 22 8.29 22 10.5ZM2 13.5V15.5H8V17.5H16V15.5H22V13.5H2ZM7.14 11.6C8.3 10.41 8.28 8.52 7.1 7.36C5.91 6.2 4.02 6.22 2.86 7.4C1.7 8.59 1.72 10.48 2.9 11.64C4.09 12.8 5.98 12.78 7.14 11.6Z',
      key: '85bfgk',
    },
  ],
]);

export default AirlineSeatFlat;
